import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Show, SimpleShowLayout, EditButton } from 'react-admin';
import _ from 'lodash';

const styles = {
  languageCode: {
    fontWeight: 'bold',
  },
};

const DefinitionTranslationsField = ({ record }) =>
  record.definitionTranslations != null
    ? Object.keys(record.definitionTranslations).map((languageCode) => (
        <div key={`grammar-translations-field-${languageCode}`}>
          <span style={styles.languageCode}>{languageCode}</span>
          &nbsp;
          <span>{record.definitionTranslations[languageCode]}</span>
        </div>
      ))
    : null;

DefinitionTranslationsField.defaultProps = {
  addLabel: true,
};

const GrammarShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <EditButton {...props} />
      <TextField label="Text" source="text" />
      <TextField label="Type" source="type" />
      {_.get(props.record, 'definitionTranslations', null) ? (
        <DefinitionTranslationsField label="Definition Translations" />
      ) : null}
    </SimpleShowLayout>
  </Show>
);

GrammarShow.propTypes = {
  record: PropTypes.shape({}),
};

GrammarShow.defaultProps = {
  record: null,
};

export default GrammarShow;
